import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_DPR } from '../../../config/constant/unityConstants';

const utilities = createSlice({
  name: 'utilities',
  initialState: {
    curatorPanel: '',
    // globalDPR: DPR_DEFAULT_VALUE,
    globalDPR: DEFAULT_DPR, // window.devicePixelRatio || 1,
    lightEffectDisabledFromUnity: false,
  },
  reducers: {
    setCuratorPanel: (state, { payload }) => {
      state.curatorPanel = payload;
    },
    setGlobalDPR: (state, { payload }) => {
      state.globalDPR = payload;
    },
    setLightEffectDisabledFromUnity: (state, { payload }) => {
      state.lightEffectDisabledFromUnity = payload;
    },
  },
});

export const {
  curatorPanel,
  setCuratorPanel,
  globalDPR,
  setGlobalDPR,
  setLightEffectDisabledFromUnity,
} = utilities.actions;
export const utilitiesSelector = (state) => state.utilities;
export const utilitiesReducer = utilities.reducer;
export default utilitiesReducer;

export const selectGlobalDPR = (state) => state.utilities.globalDPR;
export const selectLightEffectDisabledFromUnity = (state) => state.utilities.lightEffectDisabledFromUnity;